import React, { useState, useEffect, useContext } from 'react';
import moment from "moment";
import { Theme } from '../App';

export default function Time() {
    const { theme, setTheme } = useContext(Theme);
    const startTime = moment("2023-12-05");
    const targetTime = moment("2026-11-19");
    const timeReferences = [
        99.5,
        83,
        6,
        350,
        3000,
    ];

    const [currentTime, setCurrentTime] = useState(moment());
    const timeRemaining = {
        'full': moment.duration(targetTime.diff(currentTime)),
        'years': moment(targetTime).diff(Date.now(), 'years'),
        'months': moment(targetTime).diff(Date.now(), 'months'),
        'weeks': moment(targetTime).diff(Date.now(), 'weeks'),
        'days': moment(targetTime).diff(Date.now(), 'days'),
        'hours': moment(targetTime).diff(Date.now(), 'hours'),
        'minutes': moment(targetTime).diff(Date.now(), 'minutes'),
        'seconds': moment(targetTime).diff(Date.now(), 'seconds'),
    };

    const q = Math.abs(new Date() - startTime);
    const d = Math.abs(targetTime - startTime);
    const percentageBetweenDates = Math.round((q / d) * 100);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(moment());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={`time ${theme}`}>
            <div className="time__theme">
                <button className={`time__theme__button time__theme__button--blue ${theme === "blue" ? "active" : ""}`}
                    onClick={() => setTheme("blue")}>
                    Vice Blue
                </button>
                <button className={`time__theme__button time__theme__button--pink ${theme === "pink" ? "active" : ""}`}
                    onClick={() => setTheme("pink")}>
                    Sunlight Pink
                </button>
            </div>
            {new Date() < targetTime ?
                <React.Fragment>
                    <p className="time__disclaimer">
                        The official release date is on
                        <strong> {targetTime.format('MMMM D, YYYY')}</strong>
                    </p>
                    <div className={`time__bar ${theme}`}>
                        <div className={`time__bar__progress ${theme}`}
                            style={{ 'width': (percentageBetweenDates > 100 ? 100 : percentageBetweenDates) + '%' }}></div>
                    </div>
                    <p className="time__start">
                        December 5, 2023
                        <span className="time__start__label">
                            First trailer
                        </span>
                    </p>
                    <p className="time__end">
                        {targetTime.format('MMMM D, YYYY')}
                        <span className="time__end__label">
                            Official release date
                        </span>
                    </p>
                    <div className={`time__before ${theme}`}>
                        <p className="time__before__title">
                            Before the
                            <strong> GTA VI </strong>
                            release, you have the time to...
                        </p>
                        <div className="time__before__item">
                            <p className="time__before__item__label">
                                Finish the story mode of every GTA main episode
                                <span className="time__before__item__reference time__before__item__reference--mobile"> {Math.ceil(timeRemaining.hours / timeReferences[0] * 100) / 100} times.</span>
                            </p>
                            <p className="time__before__item__reference time__before__item__reference--desktop">
                                {Math.ceil(timeRemaining.hours / timeReferences[0] * 100) / 100} times
                            </p>
                        </div>
                        <div className="time__before__item">
                            <p className="time__before__item__label">
                                Complete the story mode of GTA V (100%)
                                <span className="time__before__item__reference time__before__item__reference--mobile"> {Math.ceil(timeRemaining.hours / timeReferences[1] * 100) / 100} times.</span>
                            </p>
                            <p className="time__before__item__reference time__before__item__reference--desktop">
                                {Math.ceil(timeRemaining.hours / timeReferences[1] * 100) / 100} times
                            </p>
                        </div>
                        <div className="time__before__item">
                            <p className="time__before__item__label">
                                Complete the Doomsday Heist of GTA Online
                                <span className="time__before__item__reference time__before__item__reference--mobile"> {Math.ceil(timeRemaining.hours / timeReferences[2] * 100) / 100} times.</span>
                            </p>
                            <p className="time__before__item__reference time__before__item__reference--desktop">
                                {Math.ceil(timeRemaining.hours / timeReferences[2] * 100) / 100} times
                            </p>
                        </div>
                        <div className="time__before__item">
                            <p className="time__before__item__label">
                                Rank up to level 100 in GTA Online
                                <span className="time__before__item__reference time__before__item__reference--mobile"> {Math.ceil(timeRemaining.hours / timeReferences[3] * 100) / 100} times.</span>
                            </p>
                            <p className="time__before__item__reference time__before__item__reference--desktop">
                                {Math.ceil(timeRemaining.hours / timeReferences[3] * 100) / 100} times
                            </p>
                        </div>
                        <div className="time__before__item">
                            <p className="time__before__item__label">
                                Complete GTA Online (100%)
                                <span className="time__before__item__reference time__before__item__reference--mobile"> {Math.ceil(timeRemaining.hours / timeReferences[4] * 100) / 100} times.</span>
                            </p>
                            <p className="time__before__item__reference time__before__item__reference--desktop">
                                {Math.ceil(timeRemaining.hours / timeReferences[4] * 100) / 100} times
                            </p>
                        </div>
                    </div>
                </React.Fragment>
                : <React.Fragment>
                    <p className="time__disclaimer">
                        <span>Grand Theft Auto VI</span><br />is out since
                        <strong> {targetTime.format('MMMM D, YYYY')}</strong>.
                    </p>
                    {Math.abs(timeRemaining.years) > 0 &&
                        <p className="time__since">
                            Since
                            <strong> {Math.abs(timeRemaining.years)} years.</strong>
                        </p>
                    }
                    {Math.abs(timeRemaining.months) > 0 &&
                        <p className="time__since">
                            Since
                            <strong> {Math.abs(timeRemaining.months)} months.</strong>
                        </p>
                    }
                    {Math.abs(timeRemaining.days) > 0 &&
                        <p className="time__since">
                            Since
                            <strong> {Math.abs(timeRemaining.days)} days.</strong>
                        </p>
                    }
                    {Math.abs(timeRemaining.hours) > 0 &&
                        <p className="time__since">
                            Since
                            <strong> {Math.abs(timeRemaining.hours)} hours.</strong>
                        </p>
                    }
                    {Math.abs(timeRemaining.minutes) > 0 &&
                        <p className="time__since">
                            Since
                            <strong> {Math.abs(timeRemaining.minutes)} minutes.</strong>
                        </p>
                    }
                    {Math.abs(timeRemaining.seconds) > 0 &&
                        <p className="time__since">
                            Since
                            <strong> {Math.abs(timeRemaining.seconds)} seconds.</strong>
                        </p>
                    }
                    <p className="time__disclaimer">
                        And it's still
                        <strong> the best game ever</strong>.
                    </p>
                </React.Fragment>
            }
        </div>
    )
}